import { lazy } from 'react';
import { registerModuleRoute } from 'app/navigation/routeRegistry';
import { ModuleRoute } from 'app/navigation/routeRegistry';
import { HISTORY_SCREEN_NAMES } from './navigation/HistoryNavigation';

const HistoryNavigation = lazy(() => import('./navigation/HistoryNavigation'));
const historyRoutes: ModuleRoute = {
    id: 'history',
    Stack: HistoryNavigation,
    meta: {
        placement: 'tab',
        tabLabel: 'Storico',
        tabIcon: 'fund',
        order: 20,
    },
    screenNames: HISTORY_SCREEN_NAMES,
};


registerModuleRoute(historyRoutes);

export { UploadDocumentModal } from './components/documents/UploadDocumentModal';
export { PhotoReviewModal } from './components/documents/PhotoReviewModal';
export { useDocumentUpload } from './hooks/useDocumentUpload';
export { useDocumentDownload } from './hooks/useDocumentDownload';
export { default as TeleassistanceDetailScreen } from './screens/TeleassistanceDetailScreen';
export { useUploadSession } from './hooks/useUploadSession';
export { useCountdown } from './hooks/useCountdown';
export { TelemonitoringReportCard } from './components/reports/ReportCard';
export * from './types';